import React, { Component } from 'react';
import { Form, DatePicker } from 'antd';
import moment, { isMoment } from 'moment';

export class ContractAnnex extends Component {

  render() {
    const { limitEdit, unlimitEdit, isDriverless } = this.props;
    return <>
      <div className="title-contract title-special">
        {`${isDriverless ? '12' : '13'}.  Hiệu lực HĐ đi kèm có giá trị thay đổi từ`}
        </div>
      <Form.Item
        name="effective_date"
        wrapperCol={24}
        dependencies={['to_datetime']}
        className="punishment"
        hasFeedback
        rules={[
          ({ getFieldValue }) => ({
            validator(rule, value) {
              const endDate = getFieldValue('to_datetime');
              if (!isMoment(value)) {
                if (!limitEdit || (unlimitEdit && limitEdit)){
                  return Promise.resolve();
                } else {
                  return Promise.reject('Thời gian hiệu lực là bắt buộc');
                }
                
              }
              if (!isMoment(endDate)) {
                return Promise.resolve();
              }
              if (endDate && value.unix() > endDate.endOf('day').unix()) {
                return Promise.reject('Thời gian hiệu lực phải nhỏ hơn hoặc bằng ngày kết thúc hợp đồng');
              }
              
              if (value.unix() < moment().startOf('day').unix()) {
                return Promise.reject('Thời gian hiệu lực phải lớn hơn hiện tại');
              }
              return Promise.resolve();
            },
          }),
        ]
        }
      >
        <DatePicker
          // inputReadOnly
          disabled={!limitEdit || (unlimitEdit && limitEdit)}
          dropdownClassName="date-contract-annex"
          getPopupContainer={node => {
            if (node) {
              return node.parentNode;
            }
            return document.body;
          }} format='DD/MM/YYYY' style={{ width: '100%' }} />
      </Form.Item>
    </>
  }
}